// eslint-disable-next-line import/prefer-default-export
export const BULK_ACTION_LIMIT = 2_000;
